/**
 * @created on 2017/9/19
 * @author laixinyu <laixinyualex@gmail.com>
 **/

import { getRunTime } from '../../../public-resource/libs/utils/index'

// 判断环境
let HOST = getRunTime('//m.xinli001.com')
let YIAPI_HOST = getRunTime('//yiapi.xinli001.com')
let protocol = window.location.protocol
let IS_APP = window.$platform.isYixinliApp

module.exports = {
  host: protocol + HOST,
  rankList: `${HOST}/qa/answer-ranking-list`,
  postQuestion: `${HOST}/qa/post-question-view`, // 向ta提问
  getWXShareConfig: `${HOST}/wx/get-wx-package.json`,
  articleIndex: `${HOST}/common/get-object-info.json`,
  isLogin: `${HOST}/ajax/get-user-header`,
  login: IS_APP
    ? 'yixinli://open_user_login'
    : `${HOST}/account/login?next=${encodeURIComponent(
        protocol + HOST + location.pathname + location.search + location.hash
      )}`,
  shareGroup: `${YIAPI_HOST}/v5/yi/save-user-growth-task.json`,
  favourite: `${HOST}/ajax/article-fav-toggle.json`,
  toggleZanUrl: `${HOST}/ajax/article-like-toggle.json`,
  articleDetail: `${YIAPI_HOST}/v5/yi/article-new-detail.json`,
  getInviteNum: `${HOST}/qa/get-user-invite-num.json`, // 获取用户剩余问答邀请数
  followAttention: `${HOST}/ajax/user-follow-toggle1.json` // 关注用户
}



// WEBPACK FOOTER //
// ./src/pages/ask/rankingList/api.js